// ======================================================================
// File Name       : AuthorityTop
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Form, Table, Button, Col } from 'react-bootstrap';
import { SELECT_TARGET_DATA, RETURN_MAX_NUM_1000 } from '../../constants/index';
import { USER_AUTHORITY_ROLE } from '../../constants/AuthorityConstant';
import { AUTHORITY } from '../../constants/PathConstants';
import { getAuthorityList } from '../../actions/AuthorityAction';
import DialogConfirm from '../../components/DialogConfirm';
import * as MessageTemplate from '../../constants/MessageTemplate';
import PaginationCustom from '../../components/Pagination';
import Header from '../../components/Header';
import CustomButton from '../../components/button/CustomButton';
import * as FUNCTION from '../../constants/FunctionConstants';
import * as Path from '../../constants/PathConstants';
import * as ICON from '../../constants/IconConstants';
import CustomLink from '../../components/button/CustomLink';
import { canAccessRoute } from '../../utils/AuthedUtils';

class AuthorityTopContainer extends React.Component {
  /**
     * Constructor function of component
     * @param {*} props
     */
  constructor(props) {
    super(props);
    this.state = {
      authorityInfo: {
        managementAuthorityList: [],
      },
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM_1000,
      showBatchExportConfirm: false,
    };
    this.onSearchData = this.onSearchData.bind(this);
    this.onBatchExportCancel = this.onBatchExportCancel.bind(this);
    this.onBatchExportOk = this.onBatchExportOk.bind(this);
    this.openBatchExportConfirmDialog = this.openBatchExportConfirmDialog.bind(this);
    this.getAuthorityList = this.getAuthorityList.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
  }

  /**
     * Life cycle function of component
     */
  componentWillMount() {
    this.onSearchData();
  }

  /**
   * Life cycle function
   */
  componentWillReceiveProps(nextProps) {
    const { authority } = nextProps;
    const { authorityInfo } = authority;
    this.setState({
      authorityInfo,
    });
  }

  onSearchData() {
    this.setState(
      {
        startPosition: 0,
        returnMaxNum: RETURN_MAX_NUM_1000,
      },
      () => this.getAuthorityList(SELECT_TARGET_DATA.DATA),
    );
  }

  /**
     * Get service list
     *
     * @param {integer} selectTargetData
     */
  getAuthorityList(selectTargetData) {
    const auth = this.props.auth;
    const param = {
      startPosition: this.state.startPosition,
      returnMaxNum: this.state.returnMaxNum,
      selectTargetData,
    };
    this.props.dispatch(getAuthorityList(param));
  }

  /**
     * Pagination
     * @param {*} page
     */
  getStartEndData(startPosition) {
    this.setState(
      {
        startPosition,
      },
      () => {
        this.getAuthorityList(SELECT_TARGET_DATA.DATA);
      },
    );
  }

  /**
     * Show dialog confirm
     * @param {*} mdContent
     * @param {*} mdSize
     */
  openBatchExportConfirmDialog() {
    this.content = MessageTemplate.BULK_EXPORT;
    this.setState({ showBatchExportConfirm: true });
  }

  /**
     * Event click button cancel of dialog confirm
     */
  onBatchExportCancel() {
    this.setState({ showBatchExportConfirm: false });
  }

  /**
     * Event click button ok of dialog confirm
     */
  onBatchExportOk() {
    this.setState({ showBatchExportConfirm: false });
    this.getAuthorityList(SELECT_TARGET_DATA.CSV);
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  /**
     * Render function of component
     */
  render() {
    const authorityList = this.state.authorityInfo.managementAuthorityList.map(
      (authority, index) => {
        let btnName = '詳細を見る';
        let className = 'link-detail';
        if (
          authority.managementAuthoritySecernId !== USER_AUTHORITY_ROLE.ADMIN &&
          authority.managementAuthoritySecernId !== USER_AUTHORITY_ROLE.TEACHER &&
          authority.managementAuthoritySecernId !== USER_AUTHORITY_ROLE.SCORING_MANAGEMENT &&
          authority.managementAuthoritySecernId !== USER_AUTHORITY_ROLE.HISTORY_VIEWING // Step 1
        ) {
          btnName = '詳細';
          className = 'link-detail-edit';
        }
        const link = `/${AUTHORITY}/${authority.managementAuthoritySecernId}`;
        return (
          <tr key={authority.managementAuthoritySecernId} onMouseEnter={() => this.handleMouseEnter(index)} onMouseLeave={() => this.handleMouseLeave()}>
            <td>
              {authority.managementAuthorityName}
            </td>
            <td className="text-center">
              <CustomLink
                className={`margin-right-7 ${className}`}
                to={link}
                text={btnName}
              />
            </td>
          </tr>
        );
      },
    );
    const canAccessImport = canAccessRoute(FUNCTION.AUTHORITY_IMPORT);
    const canAccessRegister = canAccessRoute(FUNCTION.AUTHORITY_REGISTER);
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.USER_LIST}
          text="ユーザー管理に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="ロール管理" />
        <Col sm={12} className="margin-bottom-15">
          <Col sm={7}>
            {canAccessRegister && (
              <CustomLink
                className="btn-register margin-right-10"
                to={Path.AUTHORITY_REGISTER}
                text="ロール追加"
                icon={ICON.REGIST}
              />
            )}
            {canAccessImport && (
              <CustomLink
                className="margin-right-7 btn-csv-import"
                to={Path.AUTHORITY_IMPORT}
                text="CSV一括投入"
                icon={ICON.IMPORT}
              />
            )}

          </Col>
          <Col sm={5} className="display-flex justify-content-end float-end">
            <CustomButton
              btnStyle="btn btn-export-csv"
              handleClick={this.openBatchExportConfirmDialog}
              text="一括出力"
              iconClass="bi bi-download"
            />
          </Col>
        </Col>
        <Table striped hover>
          <thead>
            <tr>
              <th>ロール名</th>
              <th width="150">
                操作
              </th>
            </tr>
          </thead>
          <tbody>
            {authorityList}
          </tbody>
        </Table>
        <DialogConfirm
          showModal={this.state.showBatchExportConfirm}
          onCancel={this.onBatchExportCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onBatchExportOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ authority: state.authority },
});

export default connect(mapStateToProps)(AuthorityTopContainer);
